import React, { createContext } from "react";
import App from "./App";
import Footer from "./components/Footer";
import useFetch from "./hooks/useFetch";

export const StaticContentContext = createContext();

function Layout() {
  const [staticContent, loading] = useFetch("/static", {});

  return (
    <StaticContentContext.Provider value={{staticContent, notFoundEndpoint: "/mistet-side"}}>
      <App />
      {loading ? null : (
        <Footer />
      )}
    </StaticContentContext.Provider>
  );
}

export default Layout;
